export function mapObject<K extends string, T, U>(
  obj: { [P in K]: T },
  fn: (x: T, k?: K) => U
): { [P in K]: U } {
  const r: any = {};
  Object.keys(obj).forEach(k => {
    const kk = k as K;
    const t = obj[kk];
    console.log(t, kk);
    r[kk] = fn(t, kk);
  });
  return r;
}

export async function PromiseMap<T>(pmap: { [P in keyof T]: Promise<T[P]> }) {
  const r: any = {}
  await Promise.all(Object.keys(pmap).map(key => (async () => {
    r[key] = await pmap[key as (keyof T)]
  })()))
  return r as T
}

export function u_katakanize(str: string) {
  return str.replace(/[\u3041-\u3096]/g, m => String.fromCharCode(m.charCodeAt(0) + 0x60))
}

export function u_hankakunize(str: string) {
  return str.replace(/[！-～]/g, tmpStr => String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0))
    .replace(/’/g, "'")
    .replace(/‘/g, "`")
    .replace(/￥/g, "\\")
    .replace(/　/g, " ")
    .replace(/〜/g, "~");
}

export function u_hankakunize_digit(str: string) {
  return str.replace(/[０-９]/g, d => String.fromCharCode(d.charCodeAt(0) - 0xFEE0))
}

export function u_upcase_jp(str: string): string {
  return str.replace(/[ァィゥェォッャュョ]/g, c => {
    const h: { [key: string]: string } = {
      "ァ": "ア",
      "ィ": "イ",
      "ゥ": "ウ",
      "ェ": "エ",
      "ォ": "オ",
      "ッ": "ツ",
      "ャ": "ヤ",
      "ュ": "ユ",
      "ョ": "ヨ",
    };
    return h[c] || c
  })
}

export function u_remove_accessories(str: string) {
  return str.replace(/[・\-•=　 ]/g, "");
}

export function u_datify(data: any) {
  if (data instanceof Date) { return data; }
  if (typeof data === "number") {
    return new Date(data);
  }
  if (typeof data === "object") {
    if (typeof data._seconds === "number" && typeof data._nanoseconds === "number") {
      return new Date(data._seconds * 1000 + data._nanoseconds / 1000);
    }
  }
  return undefined;
}
